module.exports = __webpack_public_path__ + "static/img/优必选工业人形机器人Walker S1.a755e8ba.png";